import { useState } from "react";
import { isTV } from "../../../utils/platform";
import DesktopLayout from "../PairControllerItems/DesktopLayout";
import MobileLayout from "../PairControllerItems/MobileLayout";
import { useAppSelector } from "../../hooks";
import { selectIsDesktopView } from "../../../store/slices/appState";

type TPairControllerPopup = {
  onClose?: () => void;
  open: boolean;
};

const PairControllerPopup: React.FC<TPairControllerPopup> = (props) => {
  const { onClose, open } = props;
  const [videoError, setVideoError] = useState(false);
  const isDesktop = useAppSelector(selectIsDesktopView);

  return !isDesktop ? (
    <MobileLayout
      open={open}
      onClose={onClose}
      videoError={videoError}
      setVideoError={setVideoError}
    />
  ) : (
    <DesktopLayout
      open={open}
      onClose={onClose}
      isTV={isTV}
      videoError={videoError}
      setVideoError={setVideoError}
    />
  );
};

export default PairControllerPopup;
